"use client";
import React, { useState } from "react";
import { Link } from 'react-router-dom'; // Import Link
import { EyeIcon } from '../Common/Icons';
import GoogleButton from './GoogleButton';

const LoginForm = ({ onSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState(''); // Added for inline error display

  const handleSubmit = async (e) => { // Changed to async
    console.log('Login form submitted');
    e.preventDefault();
    setFormError(''); // Clear previous error

    try {
      // onSubmit is expected to be an async function that handles the API call
      // and will throw an error if the API call fails.
      await onSubmit({ email, password }); 
    } catch (err) {
      // err is the error thrown by api.post in handleLocalLogin (from LoginPage)
      setFormError(err.response?.data?.message || err.message || 'Login gagal. Silakan coba lagi.');
    }
  };

  return (
    <form 
      onSubmit={handleSubmit} 
      noValidate
      className="flex flex-col gap-8 items-start p-8 w-full bg-white rounded-2xl shadow-xl border border-gray-100 max-w-md"
    >
      <div className="flex flex-col gap-3 justify-center items-start w-full">
        <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-2">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <h1 className="w-full text-2xl md:text-3xl font-bold text-left text-gray-900 text-center">
          Masuk Akun
        </h1>
        <p className="w-full text-sm md:text-base text-left text-gray-600 text-center">
          Masuk ke akun TERAPLUS Anda untuk melanjutkan.
        </p>
      </div>

      {/* Google Button - More prominent */}
      <GoogleButton className="w-full py-3 text-sm md:text-base" /> 

      {/* OR Divider */}
      <div className="flex gap-4 justify-center items-center w-full">
        <div className="h-px bg-gray-200 flex-grow" />
        <span className="text-xs md:text-sm text-center text-gray-500 font-medium">
          Atau Masuk dengan Email
        </span>
        <div className="h-px bg-gray-200 flex-grow" />
      </div>

      <div className="flex flex-col gap-5 items-start w-full">
        {/* Email Input */}
        <div className="flex flex-col gap-2 items-start w-full">
          <label htmlFor="email" className="w-full text-sm font-semibold text-gray-700">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Tuliskan alamat email Anda"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-gray-900 transition-all duration-200"
            required
            autoComplete="email"
          />
        </div>

        {/* Password Input */}
        <div className="flex flex-col gap-2 items-start w-full">
          <label htmlFor="password" className="w-full text-sm font-semibold text-gray-700">
            Password
          </label>
          <div className="w-full flex rounded-xl shadow-sm border border-gray-300 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/20 transition-all duration-200">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Tuliskan password Anda"
              className="flex-1 px-4 py-3 block w-full rounded-l-xl border-0 focus:ring-0 text-gray-900 placeholder-gray-400"
              required
              autoComplete="current-password"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="inline-flex items-center px-4 rounded-r-xl border-l border-gray-300 bg-gray-50 text-gray-500 hover:bg-gray-100 transition-colors duration-200"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <EyeIcon className="w-5 h-5" />
            </button>
          </div>
        </div>
        
        <div className="w-full text-right text-sm">
            <Link to="/request-password-reset" className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">Lupa Password?</Link>
        </div>

        {/* Error Message Display */}
        {formError && (
          <div className="w-full p-3 bg-red-50 border border-red-200 rounded-xl">
            <p className="text-red-700 text-sm text-center">{formError}</p>
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full flex justify-center py-3 px-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 transform hover:-translate-y-0.5"
        >
          Masuk
        </button>
      </div>

      {/* Sign Up Link */}
      <div className="flex gap-1 justify-center items-center w-full">
        <p className="text-sm text-center text-gray-600">
          Belum punya akun? <Link to="/register" className="font-semibold text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">Daftar</Link>
        </p>
      </div>
    </form>
  );
};

export default LoginForm;
